const RoleBadge = ({ role, notRegistered = false }) => {
  if (notRegistered) {
    return <span className="badge badge-red">Unregistered</span>;
  }

  const roleMap = {
    admin: { name: "GMA Admin", color: "badge-green" },
    caregiver_admin: { name: "GMA Admin", color: "badge-green" },
    caregiver: { name: "Caregiver", color: "badge-purple" },
    contact: { name: "Contact" },
    client: { name: "Client", color: "badge-white" },
  };

  if (!roleMap[role]) return null;

  const { name, color } = roleMap[role];

  return <span className={`badge ${color}`}>{name}</span>;
};

export default RoleBadge;
